import { useParams } from 'react-router-dom';
import { Typography } from '../../../../../core/components/molecules/Typography';
import Material from '../../../../../core/components/organism/Material';
import { getDisciplineName } from '../../../../../core/utils/discipline';
import { useDoneMaterial } from '../../../hooks/DailySchedule/useDoneMaterial';
import { getDoneFromPAResponse } from '../../../utils/contentDone';
import { IPAMaterialDto } from '../../../model/dailySchedule';
import { useDailyScheduleContentStore } from '../../../stores/useDailyScheduleContent';

export function PAMaterialPage() {
  const { scheduleId } = useParams();
  const { selectedContent, contentList, setContentList } =
    useDailyScheduleContentStore((s) => ({
      selectedContent: s.selectedContent,
      contentList: s.contentList,
      setContentList: s.setContentList,
    }));

  const { mutateAsync: markMaterialAsDone } = useDoneMaterial();

  async function handleMarkMaterialAsDone() {
    if (!selectedContent || !scheduleId) return;
    const response = await markMaterialAsDone({
      cronogramaId: scheduleId,
      contentId: selectedContent.content.id,
    });

    const done = getDoneFromPAResponse(response);

    const newContentList = contentList.map((item) => {
      if (item.content.id === selectedContent.content.id) {
        return { ...item, content: { ...item.content, done } };
      }
      return item;
    });

    setContentList(newContentList);
  }

  if (!selectedContent)
    return (
      <div className='flex h-full items-center justify-center'>
        <Typography>Não foi possível carregar o conteúdo.</Typography>
      </div>
    );

  const material = selectedContent.content as IPAMaterialDto;

  return (
    <div className='p-8'>
      <Material
        materialId={material.id}
        materialSlug={material.slug}
        file={material.uri}
        discipline={getDisciplineName(material.slug_area)}
        materialType={material.fileCategory}
        title={material.title}
        showFavorite={true}
        isFavorite={material.favorite}
        review={material.review ?? undefined}
        markMaterialView={() => {
          handleMarkMaterialAsDone();
        }}
      />
    </div>
  );
}
